<h1>Bild-Bibliothek</h1>
<section class="article">
  <article>
    <div class="text">
      <p>
        Die Video-Anleitung ist eine visuelle Informationsquelle. In die
        Aufbereitung der visuellen Informationen spielt auch das Corporate
        Design eines Unternehmens hinein. Dazu gehören nicht nur das
        Unternehmenslogo, sondernd auch die Auswahl und Gestaltung von
        Bildzeichen und Symbolen. Werden Pfeile, Kreise oder Haken, in welcher
        Größe und mit welchem Farbcode zur Hervorhebung verwendet? Liegt den
        Warnhinweisen die DIN EN ISO 71010 oder die ANSI Z535 zugrunde?
      </p>
      <p>
        Alle für ein Unternehmen oder einen Arbeitsbereich standardisierten
        Bildzeichen können in der Bild-Bibliothek von video2manual hinterlegt
        werden.
      </p>
      <img class="screenshot" src="assets/image_library.jpg" />
      <p>
        Der Anwender von video2manual kann sich seine Bild-Bibliothek selbst
        zusammenstellen oder er beauftragt die Erstellung eines individuellen
        Templates mit definierten Bildzeichen. Das individuelle Kundentemplate
        wird auf Grundlage des Corporate Design sowie weiterer Anforderungen
        eines Unternehmens erstellt.
      </p>
    </div>
    <a [routerLink]="['/blog']" class="call">Zurück zur Übersicht</a>
  </article>
</section>
